import { createApp } from 'vue';
import SitecoreVueBridge from '@refapp/sitecore-vue-bridge';

// Features
import TceCarouselBanner from '../../features/carousel-banner/TceCarouselBanner.vue';
import TceTransporterModule from '../../features/transporter-module/TceTransporterModule.vue';
import TceProductSliderBanner from '../../features/product-slider-banner/TceProductSliderBanner.vue';

// Components
import TceGrid from '../../components/grid/TceGrid.vue';
import TceVideoYoutube from '../../components/TceVideoYoutube/TceVideoYoutube.vue';
import TceVideo from '../../components/video/TceVideo.vue';
import TceProductRelatedSlider from '../../components/productRelatedSlider/ProductRelatedSlider.vue';
import TceSlider from '../../components/slider/TceSlider.vue';

// Directives
import { megamenu } from '../../directives/navigation/megamenu';
import { tag } from '../../directives/analyticsHandler/tag';
import { tabindex } from '../../directives/tabindex/tabindex';

// Register components
const app = createApp({
  components: {
    TceCarouselBanner,
    TceGrid,
    TceTransporterModule,
    TceProductSliderBanner,
    TceSlider,
    TceProductRelatedSlider,
    TceVideoYoutube,
    TceVideo,
  },
});

window.RefAppMctb && app.use(window.RefAppMctb);

// Register directives
Object.entries({
  megamenu,
  tag,
  tabindex,
}).forEach(([name, directive]) => app.directive(name, directive));

SitecoreVueBridge.initializeVueApp(app.mount.bind(app, '#app'));
